import React from 'react'
import dayjs from 'dayjs'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Alert } from 'antd'
import { useSelector } from 'react-redux'
import { billingSelector, optionsSelector } from 'app-redux/selectors'
import { isNaN } from 'lodash-es'

function getTrialMessage(remainingDays) {
  const hoursUntilMidnight = dayjs().endOf('day').diff(dayjs(), 'hours')
  const upgradeLink = (
    <Link to="/settings/billing/upgrade">
      <strong>
        <FormattedMessage id="billing.upgrade_now" />
      </strong>
    </Link>
  )
  const commonValues = {
    setup: upgradeLink,
  }

  if (remainingDays === 0) {
    return <FormattedMessage id="setup.trial_zero_days" values={{ setup: upgradeLink }} />
  }

  if (remainingDays === 1) {
    return (
      <FormattedMessage
        id="setup.trial_one_day"
        values={{ ...commonValues, hour: hoursUntilMidnight }}
      />
    )
  }

  return (
    <FormattedMessage
      id="setup.trial"
      values={{ ...commonValues, days: isNaN(remainingDays) ? 0 : remainingDays }}
    />
  )
}

function TrialWarning({ showIcon = true, style, ...props }) {
  const { plan, expiry_date, is_expired: isExpired } = useSelector(billingSelector)
  const { demo } = useSelector(optionsSelector)
  const remainingDays = dayjs(expiry_date).diff(dayjs(), 'days')

  if (
    !plan ||
    !expiry_date ||
    (plan && !plan.includes('Trial')) ||
    demo === 1 ||
    remainingDays < 0 ||
    isExpired
  ) {
    return null
  }

  const alertMessage = getTrialMessage(remainingDays)

  return (
    <Alert
      className="notification-demo hide-on-print alert-warning-highlight"
      style={{ borderRadius: 0, ...style }}
      message={alertMessage}
      type="warning"
      showIcon={showIcon}
      {...props}
    />
  )
}

export default TrialWarning
